<!-- 向扫码机下发语音播报接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: { "parkCode":"PR2WCYG4","scanMachineId":"3571F003",
            "voiceType":1,"voiceNum":2,"voiceInterval":5},
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台对连接到云端的扫码机下发语音播报。接收语音播报指令后开始播报，间隔voiceInterval重复播报，直到voiceNum次后停止语音播报。",
                t_url: this.commonUrls.test+"cloudScanVoice",
                p_url: this.commonUrls.prod+"cloudScanVoice",
                precondition: "",
                fitSystem: "云停车场，VEMS传统停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'scanMachineId', info2: '是', info3: 'String', info4: '设备全球唯一ID' },
                        { info1: 'voiceType', info2: '是', info3: 'Integer', info4: '语音播报类型。0“请扫码支付” 1“请使用微信扫码支付” 2“请使用支付宝扫码支付” 3“请重新扫码支付” 4“请刷新付款码扫码支付” 5“支付成功” 6“支付失败”  7“支付失败，付款码已失效” 8“道闸开启成功，一路平安” 9“道闸开启失败，请联系管理员”' },
                        { info1: 'voiceNum', info2: '是', info3: 'Integer', info4: '语音播报次数。大于等于1次' },
                        { info1: 'voiceInterval', info2: '是', info3: 'Integer', info4: '语音播报间隔（单位：秒）' },
                        { info1: 'deviceType', info2: '否', info3: 'Integer', info4: '设备类型，0：一体机(不支持)；1：智慧岗亭;2:cloudparking(不支持);3:扫码机(默认)' },

                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/device/scan/cloudScanVoice.vue